import _ from 'lodash';

const LOGIN_TOKEN_ID = "brainchain_user_token";
const USER_ID = "brainchain_user_id";
const LANGUAGE_ID = "brainchain_lang";
const LAST_USED_SUB_ROLE = "brainchain_last_used_sub_role";
const LAST_USED_GROUP = "brainchain_last_used_group";
const ANCHOR_SECURITY_GOT_IT = "brainchain_anchor_security_got_it";
const BANK_DATA_COUNTRY_CODE = "brainchain_bank_data_country_code";

export class StorageApi {
    static setLoginToken(token) {
        localStorage.setItem(LOGIN_TOKEN_ID, token);
    }

    static removeLoginToken() {
        localStorage.removeItem(LOGIN_TOKEN_ID);
    }

    static getLoginToken() {
        return localStorage.getItem(LOGIN_TOKEN_ID);
    }

    static isLoginTokenAvailable() {
        return !!localStorage.getItem(LOGIN_TOKEN_ID);
    }

    static setUserId(id) {
        localStorage.setItem(USER_ID, id);
    }

    static removeUserId() {
        localStorage.removeItem(USER_ID);
    }

    static getUserId() {
        return localStorage.getItem(USER_ID);
    }

    static setLastUsedSubRole(subRole) {
        localStorage.setItem(LAST_USED_SUB_ROLE, subRole);
    }

    static getLastUsedSubRole() {
        return localStorage.getItem(LAST_USED_SUB_ROLE);
    }

    static removeLastUsedSubRole() {
        localStorage.removeItem(LAST_USED_SUB_ROLE);
    }

    static setLastUsedGroup(group) {
        localStorage.setItem(LAST_USED_GROUP, group);
    }

    static getLastUsedGroup() {
        return localStorage.getItem(LAST_USED_GROUP);
    }

    static removeLastUsedGroup() {
        localStorage.removeItem(LAST_USED_GROUP);
    }

    static setAnchorSecurityGotIt() {
        let data = JSON.parse(localStorage.getItem(ANCHOR_SECURITY_GOT_IT) || null);
        let id = this.getUserId();

        if (id) {
            if (_.isArray(data)) {
                data.push(id);
            } else {
                data = [id];
            }

            localStorage.setItem(ANCHOR_SECURITY_GOT_IT, JSON.stringify(_.uniq(data)));
        }
    }

    static getAnchorSecurityGotIt() {
        let data = JSON.parse(localStorage.getItem(ANCHOR_SECURITY_GOT_IT) || null);
        let id = this.getUserId();

        return _.isArray(data) && id && data.includes(id);
    }

    static removeUserData() {
        this.removeUserId();
        this.removeLastUsedSubRole();
        this.removeLastUsedGroup();
    }

    static setLanguage(language) {
        localStorage.setItem(LANGUAGE_ID, language);
    }

    static getLanguage() {
        return localStorage.getItem(LANGUAGE_ID);
    }

    static getBankDataCountryCode() {
        return localStorage.getItem(BANK_DATA_COUNTRY_CODE);
    }

    static setBankDataCountryCode(countryCode) {
        localStorage.setItem(BANK_DATA_COUNTRY_CODE, countryCode);
    }
}


// WEBPACK FOOTER //
// ./src/utils/storageApi.js